import { createFileRoute, Link } from '@tanstack/react-router';
import { Seo } from '@/components/marketing/Seo';
import { ResourceTile } from '@/components/hub/ResourceTile';
import { localResources } from '@/content/resources';
import { track } from '@/lib/analytics';
import { enqueueActivity } from '@/lib/progress-queue';
import { resourceKeyForWebResource } from '@/lib/web-resource-href';
import { typeScale } from '@/lib/typography';

export const Route = createFileRoute('/app/games/')({ component: GamesIndexPage });

function GamesIndexPage() {
  const games = localResources.filter((resource) => resource.category === 'Games' || resource.category === 'Puzzles');
  return (
    <div className="mx-auto max-w-5xl px-5 py-8 sm:px-8">
      <Seo
        title="Games — Hmonglus"
        description="Match, spell, guess, and fly Ya! Ya! — the same Hmong practice games from the app."
        path="/app/games"
      />
      <p className="text-sm font-bold uppercase tracking-[.18em] text-[#2d7a13]">Play</p>
      <h1 className={`mt-1 ${typeScale.screenTitle}`}>Games</h1>
      <p className="mt-2 max-w-xl text-slate-600">Match, spell, guess, and fly Ya! Ya! — the same practice games from the app.</p>
      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3">
        {games.map((resource) => (
          <ResourceTile
            key={resource.href}
            resource={resource}
            widthClass="w-full"
            onOpen={() => {
              track('Learning Hub Press', { resource: resource.slug, category: resource.category });
              void enqueueActivity('resource_tap', {
                resource_key: resourceKeyForWebResource(resource),
                category: resource.category,
              });
            }}
          />
        ))}
      </div>
      <p className="mt-10 text-sm text-slate-500">
        Looking for lessons?{' '}
        <Link to="/app/resources" className="font-bold text-[#2d7a13]">
          Back to Learning Hub
        </Link>
      </p>
    </div>
  );
}
